import React, { useEffect, useRef } from 'react';
import './WhyNowSection.css';

const WhyNowSection: React.FC = () => {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observerCallback = (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, {
      threshold: 0.1,
      rootMargin: '0px 0px -30px 0px'
    });

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} id="porque-agora" className="why-now-section">
      <div className="container">
        <div className="why-now-content">
          <div className="why-now-header">
            <h2>Porquê Agora</h2>
            <div className="why-now-divider"></div>
          </div>

          <div className="why-now-text">
            <p>
              As equipas comerciais perdem horas entre dados dispersos, ERPs lentos e emails repetitivos.
              O Crafteer transforma isso em decisões claras e ação automática — para que a sua equipa
              venda mais e o cliente sinta proximidade.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyNowSection;
